import type { CatalogueEntry } from "../types";
import imageLight from "../images/building-height.light.webp";
import imageDark from "../images/building-height.dark.webp";

export const entry: CatalogueEntry = {
  slug: "building-height",
  displayName: `Building Height`,
  datasetProductCode: `BUILDING-HEIGHT`,
  subtitle: `Roof, Eave and Volume Insights for Australian Buildings`,
  shortDescription: `The Building Height Insight Pack is a national digital dataset that provides building height information across all Australian states and territories. It includes attributes such as roof height, eave height, building volume and estimated floors, which are derived from building height information.
Building Height is an insight pack that extends the National Buildings product with height attribution for buildings captured from aerial imagery. Each record links 1:1 to a building in the Buildings product through the building_pid, so height insights can be joined directly to building footprints and their property, cadastre and address relationships.`,
  metadata: {
    dateAdded: 1787270400000,
    dataType: ["Aspatial"],
    totalFeatureCount: 15774814,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/building_height_insight_pack/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/building_height_insight_pack/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `Building Height National Buildings Insight Pack Roof Height Eave Height Building Volume Estimated Floors 5g 5g Modelling Line of Sight Telecommunications Urban Planning Overshadowing Development Solar Bushfire Elevation DSM Aerial Imagery Geoscape Buildings Height`,
  detail: () => import("../details/building-height").then((m) => m.detail),
};

export default entry;
